export default __webpack_public_path__ + "static/summer_containers51-edea4ce745fb9e4882810edfaa5c0021.webp";